import { Injectable } from '@angular/core';
import { Toast, ToastService } from '@inera/common';

@Injectable()
export class NotificationService {
  constructor(private toastService: ToastService) {}

  public success(message: string, title?: string): void {
    const toast: Toast = {
      type: 'success',
      message
    };

    if (title) {
      toast.title = title;
    }

    this.toastService.addToast(toast);
  }

  public error(message: string, title?: string): void {
    const toast: Toast = {
      type: 'danger',
      message
    };

    if (title) {
      toast.title = title;
    }

    this.toastService.addToast(toast);
  }

  public warning(message: string, title?: string): void {
    const toast: Toast = {
      type: 'warning',
      message
    };

    if (title) {
      toast.title = title;
    }

    this.toastService.addToast(toast);
  }
}
